import {
    FETCH_ACCOUNT_STATUS_REQUEST,
    FETCH_ACCOUNT_STATUS_SUCCESS,
    FETCH_ACCOUNT_STATUS_FAILURE
} from './constants';

const initialState = {
    data: [],
    total:0,
    loading: false,
    error: null,
}

export const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_ACCOUNT_STATUS_REQUEST:
            return { ...state, loading: true }
        case FETCH_ACCOUNT_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                total: action.payload.meta?.total ?? 0,
            }
        case FETCH_ACCOUNT_STATUS_FAILURE:
            return { ...state, loading: false, error: action.payload }
        default:
            return state
    }
}

